module.exports = __webpack_public_path__ + "img/32.daf609e9.jpg";